<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.mail_template')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ email_title: true ,email_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="mailinfo/list" :showPage="true">
          <template v-slot:detail="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="handleClick(data.row)"
            />
            <!-- <Poptip
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>-->
          </template>
        </myTable>
      </div>
    </div>
    <Modal v-model="modal" :title="$t('edit')" :mask-closable="false" width="600">
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="90" label-colon>
          <Tabs :value="tabs" @on-click="ontabs">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="item">
                <FormItem prop="zh-cn_title" :label="$t('cms_email.title')">
                  <Input
                    type="text"
                    v-model="form['zh-cn_title']"
                    :placeholder="$t('cms_email.int_title')"
                  ></Input>
                </FormItem>
                <FormItem prop="zh-cn_mailname" :label="$t('cms_email.name')">
                  <Input
                    type="text"
                    v-model="form['zh-cn_mailname']"
                    :placeholder="$t('cms_email.int_name')"
                  ></Input>
                </FormItem>
                <FormItem prop="zh-cn_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form['zh-cn_content']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :placeholder="$t('cms_email.int_content')"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="item">
                <FormItem prop="zh-tw_title" :label="$t('cms_email.title')">
                  <Input type="text" v-model="form['zh-tw_title']" placeholder="請輸入郵件標題"></Input>
                </FormItem>
                <FormItem prop="zh-tw_mailname" :label="$t('cms_email.name')">
                  <Input type="text" v-model="form['zh-tw_mailname']" placeholder="請輸入郵件名字"></Input>
                </FormItem>
                <FormItem prop="zh-tw_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form['zh-tw_content']"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="請輸入郵件內容"
                  />
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="item">
                <FormItem prop="en_title" :label="$t('cms_email.title')">
                  <Input
                    type="text"
                    v-model="form.en_title"
                    placeholder="Please enter the mail title"
                  ></Input>
                </FormItem>
                <FormItem prop="en_mailname" :label="$t('cms_email.name')">
                  <Input
                    type="text"
                    v-model="form.en_mailname"
                    placeholder="Please enter the mail name"
                  ></Input>
                </FormItem>
                <FormItem prop="en_content" :label="$t('cms_email.content')">
                  <Input
                    v-model="form.en_content"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="Please enter the message content"
                  />
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";

export default {
  name: "template2",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      tabs: '1',
      columns: [
        {
          title: this.$t("cms_email.id"),
          key: "mailinfo_id",
          align: "center"
        },
        {
          title: this.$t("cms_email.addTime"),
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("cms_email.title"),
          key: "title",
          align: "center"
        },
        {
          title: this.$t("cms_email.name"),
          key: "mailname",
          align: "center"
        },
        {
          title: this.$t("cms_email.content"),
          tooltip: true,
          key: "content",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "detail"
        }
      ],
      search: { page: 1, limit: 10 },
      modal: false,
      form: {
        mailinfo_id: "",
        en_content: "",
        en_title: "",
        en_mailname: "",
        "zh-cn_content": "",
        "zh-cn_title": "",
        "zh-cn_mailname": "",
        "zh-tw_title": "",
        "zh-tw_content": "",
        "zh-tw_mailname": ""
      },
      ruleInline: {
        'zh-cn_title': [
          {
            required: true,
            message: this.$t('cms_email.int_title'),
            trigger: "blur"
          }
        ],
        'zh-cn_mailname': [
          {
            required: true,
            message: this.$t('cms_email.int_name'),
            trigger: "blur"
          }
        ],
        'zh-cn_content': [
          {
            required: true,
            message: this.$t('cms_email.int_content'),
            trigger: "blur"
          }
        ],
        'zh-tw_title': [
          {
            required: true,
            message: '請輸入郵件標題',
            trigger: "blur"
          }
        ],
        'zh-tw_mailname': [
          {
            required: true,
            message: '請輸入郵件名字',
            trigger: "blur"
          }
        ],
        'zh-tw_content': [
          {
            required: true,
            message: '請輸入郵件內容',
            trigger: "blur"
          }
        ],
        en_title: [
          {
            required: true,
            message: 'Please enter the mail title',
            trigger: "blur"
          }
        ],
        en_mailname: [
          {
            required: true,
            message: 'Please enter the mail name',
            trigger: "blur"
          }
        ],
        en_content: [
          {
            required: true,
            message: 'Please enter the message content',
            trigger: "blur"
          }
        ]
      },
    };
  },
  created () { },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    cancel () {
      this.modal = false;
    },
    submit (name) {
      if (this.form['zh-cn_content'] == '' || this.form['zh-cn_title'] == '' || this.form['zh-cn_mailname'] == '') {
        this.tabs = '1'
      } else if (this.form['zh-tw_content'] == '' || this.form['zh-tw_title'] == '' || this.form['zh-tw_mailname'] == '') {
        this.tabs = '2'
      } else if (this.form.title == '' || this.form.mailname == '' || this.form.en_content == '') {
        this.tabs = '3'
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            'mailinfo/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$base.msgSuccess(this.$t("op_ok"));
              this.$refs.table.getLoad();
            }
          );
        } else {
          this.error()
        }
      });
    },
    ontabs (item) {
      this.tabs = item
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleClick (item) {
      this.$refs.form.resetFields();
      this.$base.showLoading();
      this.$request.sendPost(
        'mailinfo/before-upd',
        { mailinfo_id: item.mailinfo_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.form = data.info
        }
      );
      this.tabs = '1'
      this.modal = true;
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'mailinfo/del',
        { mailinfo_id: item.mailinfo_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .detail_del {
    padding: 0 10px;
    color: #ed4014;
  }
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
/deep/ .modal {
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 20px 0 20px 10%;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/email/template/template.vue